import { render, staticRenderFns } from "./GalleryNew.vue?vue&type=template&id=3844a8b0&"
import script from "./GalleryNew.vue?vue&type=script&lang=js&"
export * from "./GalleryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3844a8b0')) {
      api.createRecord('3844a8b0', component.options)
    } else {
      api.reload('3844a8b0', component.options)
    }
    module.hot.accept("./GalleryNew.vue?vue&type=template&id=3844a8b0&", function () {
      api.rerender('3844a8b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GalleryNew.vue"
export default component.exports